import DefaultUserIcon from "@/common/images/icons/profileIcon.svg";
import { VerifiedIcon } from "@/components/UI/VerifiedIcon";
import { nFormatter } from "@/common/utils/parseNumber";
import { useNavigate } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import { useUserSubscription } from "@/common/hooks/useUserSubscription";
import { useCallback } from "react";
import "./ProfileCard.scss";

interface IProfileCard {
  userName: string;
  verified: boolean;
  isStudio: boolean;
  followers: number;
  profileImageUrl: string | null;
  highlightText?: React.ReactElement;
  userId: string;
  hasSubscribeMsg?: boolean;
  onClick?: () => void;
}

export const ProfileCard = ({
  userName,
  verified,
  isStudio,
  followers,
  profileImageUrl,
  userId,
  highlightText,
  hasSubscribeMsg,
  onClick
}: IProfileCard) => {
  const navigate = useNavigate();
  const { subscribed, subscribe } = useUserSubscription(userId, !!hasSubscribeMsg);

  const handleClick = useCallback(() => {
    navigate(routes.user(userId));

    if (onClick) {
      onClick();
    }
  }, [navigate, onClick, userId]);

  const handleSubscribe = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    subscribe();

    if (onClick) {
      onClick();
    }
  };

  return (
    <div onClick={handleClick} aria-label={`Link to ${userName} profile`} className="profileCard">
      <div className="profileCardImageWrap">
        <img className="profileCardImage" src={profileImageUrl ?? DefaultUserIcon} alt={`Poster for ${userName}`} />
      </div>
      <div className="profileCardInfo">
        <div className="profileCardUserName">
          <span className="userName">{highlightText ?? userName ?? userId}</span>
          {verified && <VerifiedIcon isStudio={isStudio} title={`${userName} is a verified RedGIFs ${isStudio ? "Studio" : "creator"}`} />}
        </div>
        <div className="profileCardFollowers">
          {nFormatter(followers)} followers
        </div>
      </div>
      {!subscribed && <button className="profileCardFollowBtn" onClick={handleSubscribe}>Follow</button>}
    </div>
  );
};
